import { useEffect } from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react'
import theme from './theme';
import AppRoutes from './AppRoutes';
import { initAuthListener } from './stores/auth/authStore';

function App(): JSX.Element {
  useEffect(() => initAuthListener(), []);

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <AppRoutes />
      </Router>
    </ChakraProvider>
  );
}

export default App;